<div>
  <div class="mt-6 mb-4">
    <div class="flex justify-between w-full py-2 gap-2">
      <div>
        <mat-form-field class="input-tg" appearance="outline">
          <mat-label>Ordenação</mat-label>
          <mat-select [(value)]="orderBySelected" (selectionChange)="sortChange($event)">
            @for (sort of sorts; track sort){
              <mat-option [value]="sort.id">
                {{ sort.description }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="flex gap-2">
        <button mat-button class="btn-tg" (click)="addItemProposal()">Adicionar Novo</button>
      </div>
    </div>
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Pesquisa </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="flex flex-wrap gap-3">
          <mat-form-field appearance="outline" class="input-tg">
            <mat-label>Cidade Origem</mat-label>
            <input matInput [(ngModel)]="itemSearchForm.origemCidade" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="input-tg">
            <mat-label>Estado Origem</mat-label>
            <input matInput [(ngModel)]="itemSearchForm.origemEstado" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="input-tg">
            <mat-label>Cidade Destino</mat-label>
            <input matInput [(ngModel)]="itemSearchForm.destinoCidade" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="input-tg">
            <mat-label>Estado Destino</mat-label>
            <input matInput [(ngModel)]="itemSearchForm.destinoEstado" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="input-tg">
            <mat-label>Tipo Motorista</mat-label>
            <mat-select [(ngModel)]="itemSearchForm.tipoMotoristaId">
              <mat-option [value]="null">Todos</mat-option>
              @for (dt of driverTypes; track dt.id) {
                <mat-option [value]="dt.id">{{ dt.descricao }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="input-tg">
            <mat-label>Tipo Veículo</mat-label>
            <mat-select [(ngModel)]="itemSearchForm.tipoVeiculoId">
              <mat-option [value]="null">Todos</mat-option>
              @for (vt of vehicleTypes; track vt.id) {
                <mat-option [value]="vt.id">{{ vt.descricao }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="input-tg">
            <mat-label>Tipo Trecho</mat-label>
            <mat-select [(ngModel)]="itemSearchForm.tipoTrechoId">
              <mat-option [value]="null">Todos</mat-option>
              @for (st of stretchTypes; track st.id) {
                <mat-option [value]="st.id">{{ st.descricao }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="input-tg">
            <mat-label>Pax</mat-label>
            <input matInput type="number" [(ngModel)]="itemSearchForm.pax" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="input-tg">
            <mat-label>Data Início</mat-label>
            <input matInput type="date" [(ngModel)]="itemSearchForm.dataInicio" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="input-tg">
            <mat-label>Data Final</mat-label>
            <input matInput type="date" [(ngModel)]="itemSearchForm.dataFinal" />
          </mat-form-field>
        </div>
        <div class="mb-3 flex justify-end items-center gap-2">
          <button class="btn-icon" (click)="clearSearch()" [matTooltip]="'Limpar Pesquisa'"><mat-icon>replay</mat-icon></button>
          <button class="btn-icon" (click)="performSearch()" [matTooltip]="'Pesquisar'"><mat-icon>search</mat-icon></button>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div class="mt-4">
    <div>
      @if (!loading) {
        <div>
          <table-list-os
            [dataSource]="itemsList"
            [columns]="columns"
            [passengers]="true"
            (viewItem)="editItem($event)"
            (replierItem)="replierItem($event)"
            (deleteItem)="deleteItem($event)"
          />
          @if (itemsList.length > 0) {
            <mat-paginator
              [length]="numberRows"
              [pageSize]="rows"
              [pageIndex]="page - 1"
              [pageSizeOptions]="[5, 10, 20, 30]"
              (page)="onPageEvent($event)"
            >
            </mat-paginator>
          }
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  </div>
</div>
